import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import combineReducers from '../reducers/combineReducer';

const AppStore = createStore(combineReducers, applyMiddleware(thunk));

export { AppStore };
